'use strict';

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RunExtractorAction = exports.FunctionAction = exports.CodeAction = exports.ScreenCaptureAction = exports.RenderAction = exports.CaptchaAction = exports.ExtractDataAction = exports.ViewportAction = exports.GotoAction = exports.GetHTMLAction = exports.WaitLoadingAction = exports.OpenNextNewWindowInCurrentTabAction = exports.NightmareAction = exports.WaitRegionMutationAction = exports.WaitMutationAction = exports.WaitAction = exports.PaginationAction = exports.LoopAction = exports.KeyAction = exports.HoverAction = exports.FlowControlAction = exports.KeyboardAction = exports.ContentEditAction = exports.SelectChangeAction = exports.InputChangeAction = exports.ScrollAction = exports.ClickAction = exports.MouseAction = exports.EventAction = exports.FocusAction = exports.BrowserAction = exports.ReplayableAction = exports.NotImplementedError = undefined;
var _isFunction2 = require('lodash/isFunction');
var _isFunction3 = _interopRequireDefault(_isFunction2);
var _isNumber2 = require('lodash/isNumber');
var _isNumber3 = _interopRequireDefault(_isNumber2);
var _isArray2 = require('lodash/isArray');
var _isArray3 = _interopRequireDefault(_isArray2);
var _debounce2 = require('lodash/debounce');
var _debounce3 = _interopRequireDefault(_debounce2);
var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);
  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);
    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;
    if (getter === undefined) {
      return undefined;
    }
    return getter.call(receiver);
  }
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _debug = require('debug');
var _debug2 = _interopRequireDefault(_debug);
var _object = require('object.pick');
var _object2 = _interopRequireDefault(_object);
var _utils = require('./utils');
var utils = _interopRequireWildcard(_utils);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // vim: set et sw=2 ts=2 sts=2 ff=unix fenc=utf8:
// Author: Kuan Huang<kuan.huang@import.io>
// Created on 2016-11-30

var play_log = (0, _debug2.default)('replay-browser-events:play');
var NotImplementedError = exports.NotImplementedError = function (_Error) {
  _inherits(NotImplementedError, _Error);
  function NotImplementedError() {
    var _ref;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'NotImplementedError';
    _classCallCheck(this, NotImplementedError);
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return _possibleConstructorReturn(this, (_ref = NotImplementedError.__proto__ || Object.getPrototypeOf(NotImplementedError)).call.apply(_ref, [this, message].concat(args)));
  }
  return NotImplementedError;
}(Error);
NotImplementedError.displayName = 'NotImplementedError';
var Action = function () {
  _createClass(Action, [{
    key: 'input',
    get: function get() {
      return this._input || {};
    }

    /**
     * define the  variables in the Action, for example
     * ```
     * static variables = {
     *   key: Variable,
     * }
     * ```
     * @param {String} key - the key will become an attribute to the Action instance
     * @param {Variable} Variable - must be Variable
     *
     * You can access to Variable instance via action.variables.key, for example, to mark a value in action
     * as variable: `action.variables.key.variable = true` (default false).
     *
     * You can also access the value of 'key' via action.key:
     * When GET action.key, you will get a live value when `action.input` changed.
     * When SET action.key, it will change the default value of the variable.
     */,

    set: function set(value) {
      this._input = value;
    }
  }]);
  function Action(document) {
    _classCallCheck(this, Action);
    this.replayable = false;
    this.checkBlocked = true;
    this.document = document;
    this.variables = {};
    for (var key in this.constructor.variables) {
      var variable = this.variables[key] = new this.constructor.variables[key]();
      Object.defineProperty(this, key, {
        enumerable: true,
        get: variable.get.bind(variable, this),
        set: variable.set.bind(variable, this)
      });
    }
  }
  _createClass(Action, [{
    key: 'play',
    value: function play() {
      // should return a promise, or use a done callback
      throw new NotImplementedError();
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      return {
        constructor: this.constructor.displayName,
        optional: this.optional
      };
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(document, data) {
      if (!this.actions[data.constructor] || !this.actions[data.constructor].fromJSON) {
        throw new NotImplementedError();
      }
      var newObj = void 0;
      if (this.actions[data.constructor].fromJSON === this.fromJSON) {
        newObj = new this.actions[data.constructor](document);
      } else {
        newObj = this.actions[data.constructor].fromJSON(document, data);
      }
      newObj.optional = data.optional;
      return newObj;
    }
  }]);
  return Action;
}();

// Actions that should replayed (send to server side) when captured in client side
// Note: WaitRegionMutationAction is not replayable but it's a BrowserAction, because JS
// doesn't support multi-inheritance, a variable is used to mark ReplayableAction
// Idealy WaitRegionMutationAction should not inherit from ReplayableAction, the class
// kept here for back compatible.

Action.displayName = 'Action';
Action.actions = module.exports;
Action.variables = {};
exports.default = Action;
var ReplayableAction = exports.ReplayableAction = function (_Action) {
  _inherits(ReplayableAction, _Action);
  function ReplayableAction() {
    var _ref2;
    var _temp, _this2, _ret;
    _classCallCheck(this, ReplayableAction);
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref2 = ReplayableAction.__proto__ || Object.getPrototypeOf(ReplayableAction)).call.apply(_ref2, [this].concat(args))), _this2), _this2.replayable = true, _temp), _possibleConstructorReturn(_this2, _ret);
  }
  return ReplayableAction;
}(Action);
ReplayableAction.displayName = 'ReplayableAction';
;

// Actions that should executed in browser

var BrowserAction = exports.BrowserAction = function (_ReplayableAction) {
  _inherits(BrowserAction, _ReplayableAction);
  function BrowserAction() {
    _classCallCheck(this, BrowserAction);
    return _possibleConstructorReturn(this, (BrowserAction.__proto__ || Object.getPrototypeOf(BrowserAction)).apply(this, arguments));
  }
  return BrowserAction;
}(ReplayableAction);
BrowserAction.displayName = 'BrowserAction';
;
var WaitForTarget = function WaitForTarget(Base) {
  return function (_Base) {
    _inherits(_class, _Base);
    function _class() {
      _classCallCheck(this, _class);
      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }
    _createClass(_class, [{
      key: 'waitForTarget',
      value: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(target) {
          var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
          var targetCheckInterval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return utils.waitForTarget(target, timeout, targetCheckInterval, this.document);
                case 2:
                  return _context.abrupt('return', _context.sent);
                case 3:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        function waitForTarget(_x2) {
          return _ref3.apply(this, arguments);
        }
        return waitForTarget;
      }()
    }]);
    return _class;
  }(Base);
};
var FocusAction = exports.FocusAction = function (_WaitForTarget) {
  _inherits(FocusAction, _WaitForTarget);
  function FocusAction(document, target) {
    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
    _classCallCheck(this, FocusAction);
    var _this5 = _possibleConstructorReturn(this, (FocusAction.__proto__ || Object.getPrototypeOf(FocusAction)).call(this, document));
    if (target.nodeName) {
      _this5.target = utils.serializeElement(target);
    } else {
      _this5.target = target;
    }
    _this5.timeout = timeout;
    return _this5;
  }
  _createClass(FocusAction, [{
    key: 'play',
    value: function play() {
      return this.waitForTarget(this.target, this.timeout).then(function (target) {
        target.focus();
      });
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      return Object.assign(_get(FocusAction.prototype.__proto__ || Object.getPrototypeOf(FocusAction.prototype), 'toJSON', this).call(this), {
        target: this.target,
        timeout: this.timeout
      });
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(document, data) {
      return new this(document, data.target, data.timeout);
    }
  }]);
  return FocusAction;
}(WaitForTarget(BrowserAction));
FocusAction.displayName = 'FocusAction';
var EventAction = exports.EventAction = function (_WaitForTarget2) {
  _inherits(EventAction, _WaitForTarget2);

  /**
   * @param {Number} timeout: timeout fof wait for target element exists
   */
  function EventAction(document, event) {
    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
    _classCallCheck(this, EventAction);

    // lazy serialize, as DOM may not exists when object been created
    var _this6 = _possibleConstructorReturn(this, (EventAction.__proto__ || Object.getPrototypeOf(EventAction)).call(this, document, event));
    if (event && event.preventDefault) {
      _this6.trueEvent = event;
      Object.defineProperty(_this6, 'event', {
        configurable: true,
        get: _this6.getEvent.bind(_this6)
      });
    } else {
      _this6.event = event;
      Object.defineProperty(_this6, 'trueEvent', {
        configurable: true,
        get: _this6.getTrueEvent.bind(_this6)
      });
    }

    // Mark event as enumerable so lodash.deepClone will include them
    Object.defineProperty(_this6, 'event', {
      enumerable: true
    });

    // time of wait for target element exists
    _this6.timeout = timeout;
    return _this6;
  }
  _createClass(EventAction, [{
    key: 'getEvent',
    value: function getEvent() {
      if (this[EventAction.eventCache]) return this[EventAction.eventCache];
      return this[EventAction.eventCache] = utils.serializeEvent(this.trueEvent);
    }
  }, {
    key: 'getTrueEvent',
    value: function getTrueEvent() {
      if (this[EventAction.trueEventCache]) return this[EventAction.trueEventCache];
      return this[EventAction.trueEventCache] = utils.deserializeEvent(this.event, this.document);
    }
  }, {
    key: 'play',
    value: function play() {
      var _this7 = this;
      play_log(this.constructor.displayName + '.play ' + this.trueEvent.type + ' on "' + this.event.target.cssSelector + '"');
      return this.waitForTarget(this.event.target, this.timeout).then(function (target) {
        target.dispatchEvent(_this7.trueEvent);
      });
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      return Object.assign(_get(EventAction.prototype.__proto__ || Object.getPrototypeOf(EventAction.prototype), 'toJSON', this).call(this), {
        event: this.event,
        timeout: this.timeout
      });
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(document, data) {
      return new this(document, data.event, data.timeout);
    }
  }, {
    key: 'fromEvent',
    value: function fromEvent(document, event) {
      switch (event.type) {
        case 'click':
          return new ClickAction(document, event);
        case 'scroll':
          return new ScrollAction(document, event);
        case 'change':
          if (event.target.tagName == 'SELECT') {
            return new SelectChangeAction(document, event);
          } else {
            return new InputChangeAction(document, event);
          }
        case 'mouseleave':
        case 'mouseout':
        case 'mouseover':
        case 'mouseenter':
        case 'mousemove':
          return new MouseAction(document, event);
        case 'keydown':
        case 'keypress':
        case 'keyup':
          return new KeyboardAction(document, event);
        default:
          return new EventAction(document, event);
      }
    }
  }]);
  return EventAction;
}(WaitForTarget(BrowserAction));
EventAction.displayName = 'EventAction';
EventAction.eventCache = Symbol('event');
EventAction.trueEventCache = Symbol('trueEvent');
EventAction.targetCheckInterval = 100;
var MouseAction = exports.MouseAction = function (_EventAction) {
  _inherits(MouseAction, _EventAction);
  function MouseAction() {
    _classCallCheck(this, MouseAction);
    return _possibleConstructorReturn(this, (MouseAction.__proto__ || Object.getPrototypeOf(MouseAction)).apply(this, arguments));
  }
  return MouseAction;
}(EventAction);
MouseAction.displayName = 'MouseAction';
var ClickAction = exports.ClickAction = function (_MouseAction) {
  _inherits(ClickAction, _MouseAction);
  function ClickAction() {
    _classCallCheck(this, ClickAction);
    return _possibleConstructorReturn(this, (ClickAction.__proto__ || Object.getPrototypeOf(ClickAction)).apply(this, arguments));
  }
  _createClass(ClickAction, [{
    key: 'play',
    value: function play() {
      var _this10 = this;

      // Focus on target with click
      return this.waitForTarget(this.event.target, this.timeout).then(function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(target) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  // blur original active element, focus to target
                  // if target is not focusable, blur will make sure focus to body
                  document.activeElement.blur();
                  _context2.next = 3;
                  return new Promise(function (r) {
                    return setTimeout(r, 1);
                  });
                case 3:
                  // release runtime lock to let event dispatched
                  target.focus();
                  _context2.next = 6;
                  return new Promise(function (r) {
                    return setTimeout(r, 1);
                  });
                case 6:
                  return _context2.abrupt('return', _get(ClickAction.prototype.__proto__ || Object.getPrototypeOf(ClickAction.prototype), 'play', _this10).call(_this10));
                case 7:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this10);
        }));
        return function (_x7) {
          return _ref4.apply(this, arguments);
        };
      }());
    }

    // test if ClickAction looks like captcha and can be convert to CaptchaAction
  }, {
    key: 'maybeCaptcha',
    value: function maybeCaptcha() {
      var target = this.trueEvent.target;
      if (target.tagName !== 'IMG') return false;
      for (var i = 0; i < 3 && target; i++) {
        if (target.id && target.id.toLowerCase().includes('captcha')) return true;
        if (target.getAttribute('class') && target.getAttribute('class').toLowerCase().includes('captcha')) return true;
        if (target.getAttribute('alt') && target.getAttribute('alt').toLowerCase().includes('captcha')) return true;
        target = target.parentElement;
      }
      return false;
    }
  }, {
    key: 'toCaptchaAction',
    value: function toCaptchaAction() {
      return CaptchaAction.fromClickAction(this);
    }
  }]);
  return ClickAction;
}(MouseAction);
ClickAction.displayName = 'ClickAction';
var ScrollAction = exports.ScrollAction = function (_EventAction2) {
  _inherits(ScrollAction, _EventAction2);
  function ScrollAction(document, event) {
    _classCallCheck(this, ScrollAction);

    // if it's original event
    var _this11 = _possibleConstructorReturn(this, (ScrollAction.__proto__ || Object.getPrototypeOf(ScrollAction)).call(this, document, event));
    if (event && event.preventDefault) {
      if (event.target.tagName) {
        _this11.x = event.target.scrollLeft;
        _this11.y = event.target.scrollTop;
      } else {
        // target = #document
        _this11.x = document.defaultView.scrollX;
        _this11.y = document.defaultView.scrollY;
      }
    }
    return _this11;
  }
  _createClass(ScrollAction, [{
    key: 'play',
    value: function play() {
      var _this12 = this;
      play_log(this.constructor.displayName + '.play scroll(' + this.x + ', ' + this.y + ')');
      // it's more practical to just scroll to end
      var x = (0, _isNumber3.default)(this.x) ? this.x : 0;
      var hasTarget = this.event && this.event.target && this.event.target.cssSelector;
      if (!hasTarget) {
        var y = (0, _isNumber3.default)(this.y) ? this.y : document.body.scrollHeight;
        this.document.defaultView.scrollTo(x, y);
      } else {
        return this.waitForTarget(this.event.target, this.timeout).then(function (target) {
          var y = (0, _isNumber3.default)(_this12.y) ? _this12.y : target.scrollHeight;
          target.scrollLeft = x;
          target.scrollTop = y;
        });
      }
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      return Object.assign(_get(ScrollAction.prototype.__proto__ || Object.getPrototypeOf(ScrollAction.prototype), 'toJSON', this).call(this), {
        x: this.x,
        y: this.y
      });
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(document, data) {
      var self = _get(ScrollAction.__proto__ || Object.getPrototypeOf(ScrollAction), 'fromJSON', this).call(this, document, data);
      self.x = data.x;
      self.y = data.y;
      return self;
    }
  }]);
  return ScrollAction;
}(EventAction);
ScrollAction.displayName = 'ScrollAction';
var InputChangeAction = exports.InputChangeAction = function (_EventAction3) {
  _inherits(InputChangeAction, _EventAction3);
  function InputChangeAction(document, event, timeout) {
    _classCallCheck(this, InputChangeAction);
    var _this13 = _possibleConstructorReturn(this, (InputChangeAction.__proto__ || Object.getPrototypeOf(InputChangeAction)).call(this, document, event, timeout));
    if (event.preventDefault) {
      _this13.value = event.target.value;
    } else {
      _this13.value = event.value;
    }
    return _this13;
  }
  _createClass(InputChangeAction, [{
    key: 'play',
    value: function play() {
      var _this14 = this;
      return this.waitForTarget(this.event.target, this.timeout).then(function (target) {
        target.focus();
        target.value = _this14.value;
        return _get(InputChangeAction.prototype.__proto__ || Object.getPrototypeOf(InputChangeAction.prototype), 'play', _this14).call(_this14);
      });
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = _get(InputChangeAction.prototype.__proto__ || Object.getPrototypeOf(InputChangeAction.prototype), 'toJSON', this).call(this);
      json.event.value = this.variables.value;
      return json;
    }
  }]);
  return InputChangeAction;
}(EventAction);

/**
 * Action for select element which may allow multiple selection
 */

InputChangeAction.displayName = 'InputChangeAction';
InputChangeAction.variables = {
  value: _utils.Variable
};
var SelectChangeAction = exports.SelectChangeAction = function (_EventAction4) {
  _inherits(SelectChangeAction, _EventAction4);
  function SelectChangeAction(document, event, timeout) {
    _classCallCheck(this, SelectChangeAction);
    var _this15 = _possibleConstructorReturn(this, (SelectChangeAction.__proto__ || Object.getPrototypeOf(SelectChangeAction)).call(this, document, event, timeout));
    if (event.preventDefault) {
      _this15.values = [].concat(_toConsumableArray(event.target.options)).filter(function (o) {
        return o.selected;
      }).map(function (o) {
        return o.value || o.text;
      });
    } else {
      _this15.values = event.values;
    }
    return _this15;
  }
  _createClass(SelectChangeAction, [{
    key: 'play',
    value: function play() {
      var _this16 = this;
      return this.waitForTarget(this.event.target, this.timeout).then(function (target) {
        [].concat(_toConsumableArray(target.options)).forEach(function (o) {
          if (_this16.values.indexOf(o.value || o.text) != -1) {
            o.selected = true;
          } else {
            o.selected = false;
          }
        });
        return _get(SelectChangeAction.prototype.__proto__ || Object.getPrototypeOf(SelectChangeAction.prototype), 'play', _this16).call(_this16);
      });
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = _get(SelectChangeAction.prototype.__proto__ || Object.getPrototypeOf(SelectChangeAction.prototype), 'toJSON', this).call(this);
      json.event.values = this.variables.values;
      return json;
    }
  }]);
  return SelectChangeAction;
}(EventAction);

// contentEditable action

SelectChangeAction.displayName = 'SelectChangeAction';
SelectChangeAction.variables = {
  values: _utils.Variable
};
var ContentEditAction = exports.ContentEditAction = function (_EventAction5) {
  _inherits(ContentEditAction, _EventAction5);
  function ContentEditAction(document, event, timeout) {
    _classCallCheck(this, ContentEditAction);
    var _this17 = _possibleConstructorReturn(this, (ContentEditAction.__proto__ || Object.getPrototypeOf(ContentEditAction)).call(this, document, event, timeout));
    if (event.preventDefault) {
      _this17.content = event.target.innerHTML;
    } else {
      _this17.content = event.content;
    }
    return _this17;
  }
  _createClass(ContentEditAction, [{
    key: 'play',
    value: function play() {
      var _this18 = this;
      return this.waitForTarget(this.event.target, this.timeout).then(function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(target) {
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  target.focus();
                  target.innerHTML = _this18.content;

                  // dispatch fake events
                  _context3.next = 4;
                  return new KeyboardAction(_this18.document, {
                    'constructor': 'KeyboardEvent',
                    'target': _this18.event.target,
                    'typeArg': 'keydown',
                    'eventInit': {
                      'bubbles': true,
                      'cancelable': true,
                      'detail': 0,
                      'key': 'v',
                      'code': 'KeyV',
                      'location': 0,
                      'ctrlKey': false,
                      'shiftKey': false,
                      'altKey': false,
                      'metaKey': true,
                      'repeat': false,
                      'charCode': 0,
                      'keyCode': 86,
                      'which': 86
                    }
                  }).play();
                case 4:
                  _context3.next = 6;
                  return new EventAction(_this18.document, {
                    'constructor': 'InputEvent',
                    'target': _this18.event.target,
                    'typeArg': 'input',
                    'eventInit': {}
                  });
                case 6:
                  _context3.next = 8;
                  return new KeyboardAction(_this18.document, {
                    'constructor': 'KeyboardEvent',
                    'target': _this18.event.target,
                    'typeArg': 'keyup',
                    'eventInit': {
                      'bubbles': true,
                      'cancelable': true,
                      'detail': 0,
                      'key': 'Meta',
                      'code': 'MetaLeft',
                      'location': 1,
                      'ctrlKey': false,
                      'shiftKey': false,
                      'altKey': false,
                      'metaKey': true,
                      'repeat': false,
                      'charCode': 0,
                      'keyCode': 91,
                      'which': 91
                    }
                  }).play();
                case 8:
                  _context3.next = 10;
                  return _get(ContentEditAction.prototype.__proto__ || Object.getPrototypeOf(ContentEditAction.prototype), 'play', _this18).call(_this18);
                case 10:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this18);
        }));
        return function (_x8) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = _get(ContentEditAction.prototype.__proto__ || Object.getPrototypeOf(ContentEditAction.prototype), 'toJSON', this).call(this);
      json.event.content = this.variables.content;
      return json;
    }
  }]);
  return ContentEditAction;
}(EventAction);
ContentEditAction.displayName = 'ContentEditAction';
ContentEditAction.variables = {
  content: _utils.Variable
};
var KeyboardAction = exports.KeyboardAction = function (_EventAction6) {
  _inherits(KeyboardAction, _EventAction6);
  function KeyboardAction() {
    _classCallCheck(this, KeyboardAction);
    return _possibleConstructorReturn(this, (KeyboardAction.__proto__ || Object.getPrototypeOf(KeyboardAction)).apply(this, arguments));
  }
  _createClass(KeyboardAction, [{
    key: 'getTrueEvent',
    value: function getTrueEvent() {
      var _this20 = this;
      if (this[EventAction.trueEventCache]) return this[EventAction.trueEventCache];
      var trueEvent = utils.deserializeEvent(this.event, this.document);
      ['charCode', 'keyCode', 'which'].forEach(function (hackAttr) {
        var self = _this20;
        Object.defineProperty(trueEvent, hackAttr, {
          get: function get() {
            return self.event.eventInit[hackAttr];
          }
        });
      });
      return this[EventAction.trueEventCache] = trueEvent;
    }
  }]);
  return KeyboardAction;
}(EventAction);

/* flow control actions */

KeyboardAction.displayName = 'KeyboardAction';
var FlowControlAction = exports.FlowControlAction = function (_ReplayableAction2) {
  _inherits(FlowControlAction, _ReplayableAction2);
  function FlowControlAction(document, actions, name) {
    _classCallCheck(this, FlowControlAction);
    var _this21 = _possibleConstructorReturn(this, (FlowControlAction.__proto__ || Object.getPrototypeOf(FlowControlAction)).call(this, document));
    _this21.actions = actions || [];
    _this21.name = name || '';
    return _this21;
  }
  _createClass(FlowControlAction, [{
    key: 'addAction',
    value: function addAction(action) {
      this.actions.push(action);
    }
  }, {
    key: 'removeAction',
    value: function removeAction(action) {
      // TODO: need test
      var index = -1;
      if ((index = this.actions.indexOf(action)) != -1) return this.actions.splice(index, 1);
      return false;
    }
  }, {
    key: 'play',
    value: function play() {
      var _this22 = this;
      play_log(this.constructor.displayName + '.play ' + this.actions.length + ' actions');
      var p = new Promise(function (resolve) {
        resolve();
      });
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;
      try {
        var _loop = function _loop() {
          var action = _step.value;
          action.input = _this22.input;
          p = p.then(function () {
            return action.play.apply(action, arguments);
          }).then(function () {
            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              args[_key3] = arguments[_key3];
            }

            // to release js execute lock
            return new Promise(function (resolve) {
              return setTimeout(function () {
                resolve.apply(undefined, args);
              }, 1);
            });
          });
        };
        for (var _iterator = this.actions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
      return p;
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      return Object.assign(_get(FlowControlAction.prototype.__proto__ || Object.getPrototypeOf(FlowControlAction.prototype), 'toJSON', this).call(this), {
        actions: this.actions.map(function (action) {
          return action.toJSON();
        }),
        name: this.name
      });
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(document, data) {
      var _this23 = this;
      return new this(document, data.actions.map(function (action) {
        return _this23.BaseAction.fromJSON(document, action);
      }, data.name));
    }
  }]);
  return FlowControlAction;
}(ReplayableAction);
FlowControlAction.displayName = 'FlowControlAction';
FlowControlAction.BaseAction = Action;
var HoverAction = exports.HoverAction = function (_FlowControlAction) {
  _inherits(HoverAction, _FlowControlAction);
  function HoverAction() {
    _classCallCheck(this, HoverAction);
    return _possibleConstructorReturn(this, (HoverAction.__proto__ || Object.getPrototypeOf(HoverAction)).apply(this, arguments));
  }
  return HoverAction;
}(FlowControlAction);
HoverAction.displayName = 'HoverAction';
;

/**
 * keydown + keypress + keyup
 * @param {Events|Action|Event|trueEvent} action - single action of keydown/keypress/keyup
 */

var KeyAction = exports.KeyAction = function (_FlowControlAction2) {
  _inherits(KeyAction, _FlowControlAction2);
  function KeyAction(document, action) {
    _classCallCheck(this, KeyAction);
    if ((0, _isArray3.default)(action)) {
      var _this25 = _possibleConstructorReturn(this, (KeyAction.__proto__ || Object.getPrototypeOf(KeyAction)).call(this, document, action));
    } else {
      var _this25 = _possibleConstructorReturn(this, (KeyAction.__proto__ || Object.getPrototypeOf(KeyAction)).call(this, document));
      var event = action.event || action;
      if (event.preventDefault) {
        event = utils.serializeEvent(event);
      }
      _this25.addAction(new KeyboardAction(document, Object.assign({}, event, {
        typeArg: 'keydown'
      })));
      _this25.addAction(new KeyboardAction(document, Object.assign({}, event, {
        typeArg: 'keypress'
      })));
      _this25.addAction(new KeyboardAction(document, Object.assign({}, event, {
        typeArg: 'keyup'
      })));
    }
    return _possibleConstructorReturn(_this25);
  }
  return KeyAction;
}(FlowControlAction);
KeyAction.displayName = 'KeyAction';
;
var LoopAction = exports.LoopAction = function (_FlowControlAction3) {
  _inherits(LoopAction, _FlowControlAction3);
  function LoopAction(document, actions, num, arr) {
    _classCallCheck(this, LoopAction);
    var _this26 = _possibleConstructorReturn(this, (LoopAction.__proto__ || Object.getPrototypeOf(LoopAction)).call(this, document, actions));
    _this26.num = num;
    _this26.arr = arr;
    return _this26;
  }
  _createClass(LoopAction, [{
    key: 'play',
    value: function play() {
      var _this27 = this;
      play_log(this.constructor.displayName + '.play ' + this.num + ' times with ' + this.actions.length + ' actions');
      var p = new Promise(function (resolve) {
        resolve();
      });
      if (this.num) {
        for (var i = 0; i < this.num; i++) {
          p = p.then(function () {
            var _get2;
            for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
              args[_key4] = arguments[_key4];
            }
            return (_get2 = _get(LoopAction.prototype.__proto__ || Object.getPrototypeOf(LoopAction.prototype), 'play', _this27)).call.apply(_get2, [_this27].concat(args));
          });
        }
        return p;
      }
      if (this.arr) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;
        try {
          for (var _iterator2 = this.arr[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var element = _step2.value;
            //eslint-disable-line no-unused-vars
            p = p.then(function () {
              var _get3;
              for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                args[_key5] = arguments[_key5];
              }
              return (_get3 = _get(LoopAction.prototype.__proto__ || Object.getPrototypeOf(LoopAction.prototype), 'play', _this27)).call.apply(_get3, [_this27].concat(args));
            });
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
        return p;
      }
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      return Object.assign(_get(LoopAction.prototype.__proto__ || Object.getPrototypeOf(LoopAction.prototype), 'toJSON', this).call(this), {
        num: this.variables.num,
        arr: this.variables.arr
      });
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(document, data) {
      var _this28 = this;
      return new this(document, data.actions.map(function (action) {
        return _this28.BaseAction.fromJSON(document, action);
      }), data.num, data.arr);
    }
  }]);
  return LoopAction;
}(FlowControlAction);
LoopAction.displayName = 'LoopAction';
LoopAction.BaseAction = Action;
LoopAction.variables = {
  num: _utils.Variable,
  arr: _utils.Variable
};
var PaginationAction = exports.PaginationAction = function (_LoopAction) {
  _inherits(PaginationAction, _LoopAction);
  function PaginationAction() {
    _classCallCheck(this, PaginationAction);
    return _possibleConstructorReturn(this, (PaginationAction.__proto__ || Object.getPrototypeOf(PaginationAction)).apply(this, arguments));
  }
  return PaginationAction;
}(LoopAction);
PaginationAction.displayName = 'PaginationAction';
;

/* wait actions */

var WaitAction = exports.WaitAction = function (_Action2) {
  _inherits(WaitAction, _Action2);
  function WaitAction(document) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;
    _classCallCheck(this, WaitAction);
    var _this30 = _possibleConstructorReturn(this, (WaitAction.__proto__ || Object.getPrototypeOf(WaitAction)).call(this, document));
    _this30.timeout = timeout;
    return _this30;
  }
  _createClass(WaitAction, [{
    key: 'play',
    value: function play() {
      var _this31 = this;
      play_log(this.constructor.displayName + '.wait ' + this.timeout + 'ms');
      return new Promise(function (resolve) {
        setTimeout(resolve, _this31.timeout);
      });
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      return Object.assign(_get(WaitAction.prototype.__proto__ || Object.getPrototypeOf(WaitAction.prototype), 'toJSON', this).call(this), {
        timeout: this.timeout
      });
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(document, data) {
      return new this(document, data.timeout);
    }
  }]);
  return WaitAction;
}(Action);
WaitAction.displayName = 'WaitAction';
var WaitMutationAction = exports.WaitMutationAction = function (_WaitForTarget3) {
  _inherits(WaitMutationAction, _WaitForTarget3);
  function WaitMutationAction(document, mutationRecord) {
    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
    _classCallCheck(this, WaitMutationAction);
    var _this32 = _possibleConstructorReturn(this, (WaitMutationAction.__proto__ || Object.getPrototypeOf(WaitMutationAction)).call(this, document));
    _this32.replayable = false;
    _this32.type = mutationRecord.type;
    _this32.target = mutationRecord.target.nodeName ? utils.serializeElement(mutationRecord.target) : mutationRecord.target;
    _this32.attributeName = mutationRecord.attributeName;
    _this32.timeout = timeout;
    return _this32;
  }
  _createClass(WaitMutationAction, [{
    key: 'play',
    value: function play() {
      var _this33 = this;
      play_log(this.constructor.displayName + '.wait ' + this.type + ' change on "' + this.target.cssSelector + '"');
      return this.waitForTarget(this.target, this, timeout).then(function (target) {
        // eslint-disable-line no-undef
        return new Promise(function (resolve) {
          var timer = null;
          if (_this33.timeout) timer = setTimeout(function () {
            play_log(_this33.constructor.displayName + '.wait timeouted after ' + _this33.timeout + ' ms');
            rawClearup(resolve);
          }, _this33.timeout);
          var rawClearup = function rawClearup(callback) {
            if (timer) clearTimeout(timer);
            ob.disconnect();
            return callback();
          };
          var clearup = (0, _debounce3.default)(rawClearup);
          var ob = new MutationObserver(function (mutations) {
            if (_this33.type == 'attributes' && _this33.attributeName) {
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;
              try {
                for (var _iterator3 = mutations[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var m = _step3.value;
                  if (m.type == _this33.type && m.attributeName == _this33.attributeName) {
                    play_log(_this33.constructor.displayName + '.wait done');
                    clearup(resolve);
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            } else {
              play_log(_this33.constructor.displayName + '.wait done');
              clearup(resolve);
            }
          });
          var config = {};
          config[_this33.type] = true;
          ob.observe(target, config);
        });
      });
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      return Object.assign(_get(WaitMutationAction.prototype.__proto__ || Object.getPrototypeOf(WaitMutationAction.prototype), 'toJSON', this).call(this), {
        mutationRecord: (0, _object2.default)(this, ['type', 'target', 'attributeName']),
        timeout: this.timeout
      });
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(document, data) {
      return new this(document, data.mutationRecord, data.timeout);
    }
  }]);
  return WaitMutationAction;
}(WaitForTarget(BrowserAction));
WaitMutationAction.displayName = 'WaitMutationAction';
var WaitRegionMutationAction = exports.WaitRegionMutationAction = function (_WaitForTarget4) {
  _inherits(WaitRegionMutationAction, _WaitForTarget4);
  function WaitRegionMutationAction(document, target, options) {
    var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10000;
    _classCallCheck(this, WaitRegionMutationAction);
    var _this34 = _possibleConstructorReturn(this, (WaitRegionMutationAction.__proto__ || Object.getPrototypeOf(WaitRegionMutationAction)).call(this, document));
    _this34.replayable = false;
    _this34.target = target.nodeName ? utils.serializeElement(target) : target;
    _this34.options = options;
    _this34.timeout = timeout;
    return _this34;
  }
  _createClass(WaitRegionMutationAction, [{
    key: 'play',
    value: function play() {
      var _this35 = this;
      play_log(this.constructor.displayName + '.wait mutation on "' + this.target.cssSelector + '"');
      return this.waitForTarget(this.target, this.timeout).then(function (target) {
        return new Promise(function (resolve) {
          var timer = null;
          if (_this35.timeout) timer = setTimeout(function () {
            play_log(_this35.constructor.displayName + '.wait timeouted after ' + _this35.timeout + ' ms');
            rawClearup(resolve);
          }, _this35.timeout);
          var rawClearup = function rawClearup(callback) {
            if (timer) clearTimeout(timer);
            ob.disconnect();
            return callback();
          };
          var clearup = (0, _debounce3.default)(rawClearup, 100);
          var ob = new MutationObserver(function () {
            clearup(resolve);
          });
          ob.observe(target, _this35.options);
        });
      });
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      return Object.assign(_get(WaitRegionMutationAction.prototype.__proto__ || Object.getPrototypeOf(WaitRegionMutationAction.prototype), 'toJSON', this).call(this), {
        target: this.target,
        options: this.options,
        timeout: this.timeout
      });
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(document, data) {
      return new this(document, data.target, data.options, data.timeout);
    }
  }]);
  return WaitRegionMutationAction;
}(WaitForTarget(BrowserAction));

/* interface for nightmare actions */

WaitRegionMutationAction.displayName = 'WaitRegionMutationAction';
var NightmareAction = exports.NightmareAction = function (_Action3) {
  _inherits(NightmareAction, _Action3);
  function NightmareAction() {
    _classCallCheck(this, NightmareAction);
    return _possibleConstructorReturn(this, (NightmareAction.__proto__ || Object.getPrototypeOf(NightmareAction)).apply(this, arguments));
  }
  _createClass(NightmareAction, [{
    key: 'nightmare',
    get: function get() {
      return this.document;
    }
  }]);
  return NightmareAction;
}(Action);
NightmareAction.displayName = 'NightmareAction';
var OpenNextNewWindowInCurrentTabAction = exports.OpenNextNewWindowInCurrentTabAction = function (_NightmareAction) {
  _inherits(OpenNextNewWindowInCurrentTabAction, _NightmareAction);
  function OpenNextNewWindowInCurrentTabAction() {
    _classCallCheck(this, OpenNextNewWindowInCurrentTabAction);
    return _possibleConstructorReturn(this, (OpenNextNewWindowInCurrentTabAction.__proto__ || Object.getPrototypeOf(OpenNextNewWindowInCurrentTabAction)).apply(this, arguments));
  }
  return OpenNextNewWindowInCurrentTabAction;
}(NightmareAction);
OpenNextNewWindowInCurrentTabAction.displayName = 'OpenNextNewWindowInCurrentTabAction';
;
var WaitLoadingAction = exports.WaitLoadingAction = function (_NightmareAction2) {
  _inherits(WaitLoadingAction, _NightmareAction2);
  function WaitLoadingAction() {
    _classCallCheck(this, WaitLoadingAction);
    return _possibleConstructorReturn(this, (WaitLoadingAction.__proto__ || Object.getPrototypeOf(WaitLoadingAction)).apply(this, arguments));
  }
  _createClass(WaitLoadingAction, [{
    key: 'toJSON',
    value: function toJSON() {
      return Object.assign(_get(WaitLoadingAction.prototype.__proto__ || Object.getPrototypeOf(WaitLoadingAction.prototype), 'toJSON', this).call(this), {
        url: this.url
      });
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(document, data) {
      var self = new this(document, data);
      self.url = data.url;
      return self;
    }
  }]);
  return WaitLoadingAction;
}(NightmareAction);
WaitLoadingAction.displayName = 'WaitLoadingAction';
var GetHTMLAction = exports.GetHTMLAction = function (_NightmareAction3) {
  _inherits(GetHTMLAction, _NightmareAction3);
  function GetHTMLAction() {
    _classCallCheck(this, GetHTMLAction);
    return _possibleConstructorReturn(this, (GetHTMLAction.__proto__ || Object.getPrototypeOf(GetHTMLAction)).apply(this, arguments));
  }
  return GetHTMLAction;
}(NightmareAction);
GetHTMLAction.displayName = 'GetHTMLAction';
var GotoAction = exports.GotoAction = function (_NightmareAction4) {
  _inherits(GotoAction, _NightmareAction4);
  function GotoAction(document, url, options) {
    _classCallCheck(this, GotoAction);
    var _this40 = _possibleConstructorReturn(this, (GotoAction.__proto__ || Object.getPrototypeOf(GotoAction)).call(this, document));
    _this40.url = url;
    _this40.options = options;
    return _this40;
  }
  _createClass(GotoAction, [{
    key: 'toJSON',
    value: function toJSON() {
      return Object.assign(_get(GotoAction.prototype.__proto__ || Object.getPrototypeOf(GotoAction.prototype), 'toJSON', this).call(this), {
        url: this.variables.url,
        options: this.options
      });
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(document, data) {
      return new this(document, data.url, data.options);
    }
  }]);
  return GotoAction;
}(NightmareAction);
GotoAction.displayName = 'GotoAction';
GotoAction.variables = {
  url: _utils.Variable
};
var ViewportAction = exports.ViewportAction = function (_NightmareAction5) {
  _inherits(ViewportAction, _NightmareAction5);
  function ViewportAction(document, width, height) {
    _classCallCheck(this, ViewportAction);
    var _this41 = _possibleConstructorReturn(this, (ViewportAction.__proto__ || Object.getPrototypeOf(ViewportAction)).call(this, document));
    _this41.width = width;
    _this41.height = height;
    return _this41;
  }
  _createClass(ViewportAction, [{
    key: 'toJSON',
    value: function toJSON() {
      return Object.assign(_get(ViewportAction.prototype.__proto__ || Object.getPrototypeOf(ViewportAction.prototype), 'toJSON', this).call(this), {
        width: this.variables.width,
        height: this.variables.height
      });
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(document, data) {
      return new this(document, data.width, data.height);
    }
  }]);
  return ViewportAction;
}(NightmareAction);
ViewportAction.displayName = 'ViewportAction';
ViewportAction.variables = {
  width: _utils.Variable,
  height: _utils.Variable
};
var ExtractDataAction = exports.ExtractDataAction = function (_NightmareAction6) {
  _inherits(ExtractDataAction, _NightmareAction6);
  function ExtractDataAction(document, runtimeConfig) {
    _classCallCheck(this, ExtractDataAction);
    var _this42 = _possibleConstructorReturn(this, (ExtractDataAction.__proto__ || Object.getPrototypeOf(ExtractDataAction)).call(this, document));
    _this42.runtimeConfig = runtimeConfig;
    return _this42;
  }
  _createClass(ExtractDataAction, [{
    key: 'toJSON',
    value: function toJSON() {
      return Object.assign(_get(ExtractDataAction.prototype.__proto__ || Object.getPrototypeOf(ExtractDataAction.prototype), 'toJSON', this).call(this), {
        runtimeConfig: this.variables.runtimeConfig
      });
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(document, data) {
      return new this(document, data.runtimeConfig);
    }
  }]);
  return ExtractDataAction;
}(NightmareAction);
ExtractDataAction.displayName = 'ExtractDataAction';
ExtractDataAction.variables = {
  runtimeConfig: _utils.Variable
};
var CaptchaAction = exports.CaptchaAction = function (_ReplayableAction3) {
  _inherits(CaptchaAction, _ReplayableAction3);
  function CaptchaAction(document, options) {
    _classCallCheck(this, CaptchaAction);

    /**
     * Options structure
     * {
     *   "type": "RECAPTCHA" || "FUNCAPTCHA" || "IMAGECAPTCHA", // Defines which type of captcha are we trying to solve.
     *   "inputElement": "<CSS_SELECTOR>", // If type is "RECAPTCHA" or "FUNCAPTCHA", this is a css selector for main HTML element containing those captchas
     *   Else for "IMAGECAPTCHA" this is a css selector to the textbox where captcha answer should be provided.
     *   "imageElement": "<CSS_SELECTOR>", // Required only if type is "IMAGECAPTCHA", it should contain css selector to the image element that contains the actual captcha.
     * }
     */

    var _this43 = _possibleConstructorReturn(this, (CaptchaAction.__proto__ || Object.getPrototypeOf(CaptchaAction)).call(this, document));
    switch (options.type) {
      case CaptchaAction.CAPTCHA_TYPES.RECAPTCHA:
      case CaptchaAction.CAPTCHA_TYPES.FUNCAPTCHA:
        if (!options.inputElement) throw new Error('Missing required property inputElement.');
        break;
      case CaptchaAction.CAPTCHA_TYPES.IMAGECAPTCHA:
        if (!options.inputElement) throw new Error('Missing required property inputElement.');
        if (!options.imageElement) throw new Error('Missing required property imageElement.');
        break;
      default:
        throw new Error('Incorrect value for type property. Allowed values are ' + Object.keys(CaptchaAction.CAPTCHA_TYPES) + '.');
    }
    _this43.options = options;
    return _this43;
  }
  _createClass(CaptchaAction, [{
    key: 'toJSON',
    value: function toJSON() {
      return Object.assign(_get(CaptchaAction.prototype.__proto__ || Object.getPrototypeOf(CaptchaAction.prototype), 'toJSON', this).call(this), {
        options: this.options
      });
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(document, data) {
      return new this(document, data.options);
    }
  }, {
    key: 'fromClickAction',
    value: function fromClickAction(action) {
      return this.fromClickEvent(action.document, action.trueEvent);
    }
  }, {
    key: 'fromClickEvent',
    value: function fromClickEvent(document, event) {
      var element = event.target;
      while (element && !element.hasAttribute('captchafound')) {
        element = element.parentElement;
      }
      if (element && element.getAttribute('captchatype')) {
        return new CaptchaAction(document, {
          type: element.getAttribute('captchatype'),
          inputElement: utils.serializeElement(element).cssSelector
        });
      } else if (event.target.tagName === 'IMG') {
        // find nearest input as inputElement
        var inputElement = utils.findNearestElement(event.target, 'input:not([type=hidden])');
        if (!inputElement) throw new Error('cannot find captcha input box.');
        return new CaptchaAction(document, {
          type: this.CAPTCHA_TYPES.IMAGECAPTCHA,
          inputElement: utils.serializeElement(inputElement).cssSelector,
          imageElement: utils.serializeElement(event.target).cssSelector
        });
      }
    }
  }]);
  return CaptchaAction;
}(ReplayableAction);
CaptchaAction.displayName = 'CaptchaAction';
CaptchaAction.CAPTCHA_TYPES = {
  RECAPTCHA: 'RECAPTCHA',
  FUNCAPTCHA: 'FUNCAPTCHA',
  IMAGECAPTCHA: 'IMAGECAPTCHA'
};
var RenderAction = exports.RenderAction = function (_NightmareAction7) {
  _inherits(RenderAction, _NightmareAction7);
  function RenderAction(document, options) {
    _classCallCheck(this, RenderAction);
    var _this44 = _possibleConstructorReturn(this, (RenderAction.__proto__ || Object.getPrototypeOf(RenderAction)).call(this, document));
    _this44.options = options;
    return _this44;
  }
  _createClass(RenderAction, [{
    key: 'toJSON',
    value: function toJSON() {
      return Object.assign(_get(RenderAction.prototype.__proto__ || Object.getPrototypeOf(RenderAction.prototype), 'toJSON', this).call(this), {
        options: this.variables.options
      });
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(document, data) {
      return new this(document, data.options);
    }
  }]);
  return RenderAction;
}(NightmareAction);
RenderAction.displayName = 'RenderAction';
RenderAction.variables = {
  options: _utils.Variable
};
var ScreenCaptureAction = exports.ScreenCaptureAction = function (_NightmareAction8) {
  _inherits(ScreenCaptureAction, _NightmareAction8);

  /**
   * @param {*} type pdf / png
   */
  function ScreenCaptureAction(document) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'png';
    _classCallCheck(this, ScreenCaptureAction);
    var _this45 = _possibleConstructorReturn(this, (ScreenCaptureAction.__proto__ || Object.getPrototypeOf(ScreenCaptureAction)).call(this, document));
    _this45.type = type;
    return _this45;
  }
  _createClass(ScreenCaptureAction, [{
    key: 'toJSON',
    value: function toJSON() {
      return Object.assign(_get(ScreenCaptureAction.prototype.__proto__ || Object.getPrototypeOf(ScreenCaptureAction.prototype), 'toJSON', this).call(this), {
        type: this.type
      });
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(document, data) {
      return new this(document, data.type);
    }
  }]);
  return ScreenCaptureAction;
}(NightmareAction);
ScreenCaptureAction.displayName = 'ScreenCaptureAction';
var CodeAction = exports.CodeAction = function (_NightmareAction9) {
  _inherits(CodeAction, _NightmareAction9);
  function CodeAction(document, code) {
    var checkBlocked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    _classCallCheck(this, CodeAction);
    var _this46 = _possibleConstructorReturn(this, (CodeAction.__proto__ || Object.getPrototypeOf(CodeAction)).call(this, document));
    _this46.code = code;
    _this46.checkBlocked = checkBlocked;
    return _this46;
  }
  _createClass(CodeAction, [{
    key: 'toJSON',
    value: function toJSON() {
      return Object.assign(_get(CodeAction.prototype.__proto__ || Object.getPrototypeOf(CodeAction.prototype), 'toJSON', this).call(this), {
        code: (0, _isFunction3.default)(this.code) ? this.code.toString() : this.code,
        checkBlocked: this.checkBlocked
      });
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(document, data) {
      return new this(document, data.code, data.checkBlocked);
    }
  }]);
  return CodeAction;
}(NightmareAction);

/**
 * WARNING: never eval callback within node.js / nightmare context
 */

CodeAction.displayName = 'CodeAction';
var FunctionAction = exports.FunctionAction = function (_Action4) {
  _inherits(FunctionAction, _Action4);
  function FunctionAction(document, callback, args, timeout, context) {
    _classCallCheck(this, FunctionAction);
    var _this47 = _possibleConstructorReturn(this, (FunctionAction.__proto__ || Object.getPrototypeOf(FunctionAction)).call(this, document));
    _this47.timeout = timeout;
    _this47.callback = callback;
    _this47.args = args;
    // User can execute js within iframe context by specify a css selector to the iframe
    // To switch into multiple level iframes, split the selectors with `|=>`
    // e.g.  iframe#level1 |=> iframe#level2
    _this47.context = context;
    return _this47;
  }
  _createClass(FunctionAction, [{
    key: 'play',
    value: function play() {
      play_log(this.constructor.displayName + '.play');
      var callback = this.callback;
      if (!(0, _isFunction3.default)(callback)) {
        callback = eval(callback);
      }
      var args = this.args;
      if (!(0, _isArray3.default)(this.args)) {
        args = [this.args];
      }
      return callback.apply(undefined, _toConsumableArray(args));
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      return Object.assign(_get(FunctionAction.prototype.__proto__ || Object.getPrototypeOf(FunctionAction.prototype), 'toJSON', this).call(this), {
        args: this.variables.args,
        callback: (0, _isFunction3.default)(this.callback) ? this.callback.toString() : this.callback,
        timeout: this.variables.timeout,
        context: this.context
      });
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(document, data) {
      return new this(document, data.callback, data.args, data.timeout, data.context);
    }
  }]);
  return FunctionAction;
}(Action);
FunctionAction.displayName = 'FunctionAction';
FunctionAction.variables = {
  args: _utils.Variable,
  timeout: _utils.Variable
};
var RunExtractorAction = exports.RunExtractorAction = function (_NightmareAction10) {
  _inherits(RunExtractorAction, _NightmareAction10);
  function RunExtractorAction(document, config) {
    var additionalInput = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, RunExtractorAction);
    var _this48 = _possibleConstructorReturn(this, (RunExtractorAction.__proto__ || Object.getPrototypeOf(RunExtractorAction)).call(this, document));
    _this48.config = config;
    _this48.additionalInput = additionalInput;
    return _this48;
  }
  _createClass(RunExtractorAction, [{
    key: 'toJSON',
    value: function toJSON() {
      return Object.assign(_get(RunExtractorAction.prototype.__proto__ || Object.getPrototypeOf(RunExtractorAction.prototype), 'toJSON', this).call(this), {
        config: this.config,
        additionalInput: this.additionalInput
      });
    }
  }], [{
    key: 'fromJSON',
    value: function fromJSON(document, data) {
      return new this(document, data.config, data.additionalInput);
    }
  }]);
  return RunExtractorAction;
}(NightmareAction);
RunExtractorAction.displayName = 'RunExtractorAction';
RunExtractorAction.variables = {
  config: _utils.Variable,
  additionalInput: _utils.Variable
};